(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define("rb_wixui.corvid_bootstrap", ["lodash"], factory);
	else if(typeof exports === 'object')
		exports["rb_wixui.corvid_bootstrap"] = factory(require("lodash"));
	else
		root["rb_wixui.corvid_bootstrap"] = factory(root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_T9FV__) {
return 